import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import ReCAPTCHA from "react-google-recaptcha";
import APP_VERSION from "../version"; // ✅ Import version

function ContactFormPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const recaptchaRef = useRef(null);
  const navigate = useNavigate();

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValid = name && isEmailValid && subject && message && recaptchaToken;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    if (!recaptchaToken) {
      setStatus("Error: Please verify you are human.");
      return;
    }

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          subject,
          message,
          recaptchaToken,
        }),
      });

      if (res.ok) {
        setStatus("Message sent successfully.");
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
        setRecaptchaToken("");
        recaptchaRef.current.reset();
      } else {
        const data = await res.json();
        setStatus(`Error: ${data.error || "Something went wrong."}`);
      }
    } catch (err) {
      setStatus("Failed to send message. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/campwithfriends-logo.png"
          alt="Camp With Friends Logo"
          style={{ width: "200px", marginBottom: "1rem" }}
        />

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="text"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
          <textarea
            placeholder="Your Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            style={{
              resize: "vertical",
              padding: "10px",
              borderRadius: "6px",
              fontSize: "16px",
              border: "1px solid #ccc", // consistent with input fields
            }}
            required
          ></textarea>

          <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
            <ReCAPTCHA
              sitekey="6LcogiIrAAAAAMdGV06c7axuagaU2DwM0SXEK6D5"
              ref={recaptchaRef}
              onChange={(token) => setRecaptchaToken(token)}
              theme="dark"
            />
          </div>

          <button
            type="submit"
            disabled={!isValid}
            className={!isValid ? "disabled-button" : ""}
          >
            Send Message
          </button>
        </form>

        {status && (
          <div className={status.startsWith("Error") ? "error-text" : "success-text"}>
            {status}
          </div>
        )}

        {/* ✅ Footer */}
        <div className="version-text" style={{ marginTop: "40px" }}>
          <span>
            Version: <strong>{APP_VERSION}</strong>
          </span>
          <span style={{ marginLeft: "16px" }}>
            <button
              style={{ background: "none", border: "none", color: "#4cafef", textDecoration: "underline", cursor: "pointer", padding: 0 }}
              onClick={() => navigate("/")}
            >
              Return to homepage
            </button>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ContactFormPage;
